import type { SystemStyleObject } from "@hightouch/htui";

/** The marker on a report block's container, in the editor and in static HTML. */
export const REPORT_BLOCK_SELECTOR = "[data-report-block]";

// :where() adds no specificity, so scoped rules keep the strength they had and host overrides such as review highlights still win.
const OUTSIDE_REPORT_BLOCKS = `:where(:not(${REPORT_BLOCK_SELECTOR} *))`;

/** Scopes each selector rule so it stops at report blocks, which keep the report renderer's styles: `h2` becomes `h2:where(:not([data-report-block] *))`. */
export function outsideReportBlocks(
  rules: SystemStyleObject,
): SystemStyleObject {
  return Object.fromEntries(
    Object.entries(rules).map(([key, value]) =>
      isRuleBody(value) ? [scopeSelector(key), value] : [key, value],
    ),
  ) as SystemStyleObject;
}

function isRuleBody(value: unknown): boolean {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

// A pseudo-element must end its selector, so the scope goes before it.
function scopeSelector(selector: string): string {
  return selector
    .split(",")
    .map((part) => {
      const trimmed = part.trim();
      const pseudoElement = trimmed.indexOf("::");
      return pseudoElement < 0
        ? `${trimmed}${OUTSIDE_REPORT_BLOCKS}`
        : `${trimmed.slice(0, pseudoElement)}${OUTSIDE_REPORT_BLOCKS}${trimmed.slice(pseudoElement)}`;
    })
    .join(", ");
}
